// Define a class for the Swiper component that extends the HTMLElement class
class SwiperComponent extends HTMLElement {
  // The constructor is called when an object is created with the class
  constructor() {
    super(); // Call the parent class constructor
    this.modelObserver = null;
  }

  // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
  connectedCallback() {
    // Wait for the next frame to ensure DOM is fully rendered
    requestAnimationFrame(() => {
      this.initSwiper();
      this.setupModelViewObserver();
    });
  }

  // disconnectedCallback is called when the element is removed from the DOM
  disconnectedCallback() {
    if (this.modelObserver) {
      this.modelObserver.disconnect();
    }
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }

  // Method to initialize the Swiper
  initSwiper() {
    // Check if Swiper is available and element is properly connected
    if (typeof Swiper === 'undefined' || !this.isConnected) {
      return;
    }

    // Find the swiper container within this element
    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer) {
      console.warn('Swiper container not found');
      return;
    }

    // Define the options for the Swiper
    const swiperOptions = {
      slidesPerView: 1, // Number of slides per view
      spaceBetween: 0, // Space between slides
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      scrollbar: {
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },
    pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true
    },
      // Add error handling
      on: {
        init: function() {
          console.log('Swiper initialized successfully');
        }
      }
    };
    
    try {
      // Initialize the Swiper with the options on the container
      this.swiper = new Swiper(swiperContainer, swiperOptions);
      
      // Check if model view is active and set initial slide accordingly
      const productList = document.querySelector('.product-list');
      if (productList && productList.classList.contains('model-view-active')) {
        this.switchToSecondSlide();
      }
    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
  }

  // Method to setup observer for model view changes
  setupModelViewObserver() {
    const productList = document.querySelector('.product-list');
    if (!productList) return;

    // Create a MutationObserver to watch for class changes
    this.modelObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const hasModelView = productList.classList.contains('model-view-active');
          
          if (hasModelView) {
            // Switch to second slide when model view is active
            this.switchToSecondSlide();
          } else {
            // Switch back to first slide when model view is inactive
            this.switchToFirstSlide();
          }
        }
      });
    });

    // Start observing
    this.modelObserver.observe(productList, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Method to switch to second slide
  switchToSecondSlide() {
    if (this.swiper && this.swiper.slides && this.swiper.slides.length > 1) {
      // Add fade transition class for smooth transition
      const swiperContainer = this.querySelector('.swiper');
      if (swiperContainer) {
        swiperContainer.classList.add('model-toggle-transition');
        
        // Remove the class after transition to restore normal behavior
        setTimeout(() => {
          swiperContainer.classList.remove('model-toggle-transition');
        }, 600);
      }
      
      // Slide to second image
      this.swiper.slideTo(1, 500);
    }
  }

  // Method to switch to first slide
  switchToFirstSlide() {
    if (this.swiper && this.swiper.slides && this.swiper.slides.length > 0) {
      // Add fade transition class for smooth transition
      const swiperContainer = this.querySelector('.swiper');
      if (swiperContainer) {
        swiperContainer.classList.add('model-toggle-transition');
        
        // Remove the class after transition to restore normal behavior
        setTimeout(() => {
          swiperContainer.classList.remove('model-toggle-transition');
        }, 600);
      }
      
      // Slide to first image
      this.swiper.slideTo(0, 500);
    }
  }

}

// Define the custom element
customElements.define("products-swiper-component", SwiperComponent);
